var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-expansion-panels',{staticClass:"rounded-0",attrs:{"flat":"","accordion":"","value":_vm.value,"multiple":_vm.multiple},on:{"change":function($event){return _vm.updateValue($event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }